import { useContext, useCallback } from "react";
import { AuthContext } from "../contexts/AuthContext";

const useAuthFetch = () => {
  const { getToken } = useContext(AuthContext);

  const authFetch = useCallback(
    async (url, options = {}) => {
      const token = await getToken();
      return fetch(url, {
        ...options,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${token}`,
        },
      });
    },
    [getToken]
  );

  return authFetch;
};

export { useAuthFetch };
